import { render, staticRenderFns } from "./PricingSectionEx.vue?vue&type=template&id=5bf0c9a0&scoped=true"
import script from "./PricingSectionEx.vue?vue&type=script&lang=js"
export * from "./PricingSectionEx.vue?vue&type=script&lang=js"
import style0 from "./PricingSectionEx.vue?vue&type=style&index=0&id=5bf0c9a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf0c9a0",
  null
  
)

export default component.exports